import { useEffect } from 'react';
import flatMap from 'lodash/flatMap';
// useOnOutsideClick aka useOnClickOutside
export function useOnOutsideClick(rootRef, callback, enabled, checkOutsideFn) {
    if (enabled === void 0) { enabled = true; }
    useEffect(function () {
        if (!enabled) {
            return;
        }
        var checkOutsideClick = function (e) {
            var target = e.target;
            var roots = (Array.isArray(rootRef)
                ? flatMap(rootRef, function (ref) {
                    if (typeof ref === 'string') {
                        var elements = document.querySelectorAll(ref);
                        return Array.from(elements);
                    }
                    return ref.current;
                })
                : [rootRef.current]).filter(function (node) { return !!node; });
            if (roots.length === 0) {
                return;
            }
            if (
            // any of the roots contains our target
            roots.some(function (root) { return root.contains(target); }) ||
                // or it has ignore-enforcing ancestors
                target.closest('.ignore-react-onclickoutside') ||
                // or the custom checking method says the element is inside
                (checkOutsideFn && !checkOutsideFn(target, e))) {
                // this was an inside click, nothing to see here
            }
            else {
                callback(e);
            }
        };
        document.addEventListener('mousedown', checkOutsideClick);
        document.addEventListener('touchstart', checkOutsideClick);
        return function () {
            document.removeEventListener('mousedown', checkOutsideClick);
            document.removeEventListener('touchstart', checkOutsideClick);
        };
    }, [callback, rootRef, enabled, checkOutsideFn]);
}
//# sourceMappingURL=useOnOutsideClick.js.map